import { ICardElementWithChildren } from "backend/model/model";

const typeToViewMap: Record<string, string | undefined> = {
  "Strategic Objective": "objective",
  Organization: "strategymap",
  KPI: "kpidetails",
  Initiative: "initiativedetails",
};

const typeToView = (typename: string) => {
  const key = typeof typename === "string" ? typename.trim() : "";
  if (typeToViewMap[key]) {
    return typeToViewMap[key];
  }
  if (key && key.toLowerCase().replace(/\s+/g, " ") === "strategic objective") {
    return "objective";
  }
  return "";
};

export default typeToView;
